import { Checkbox as MaterialCheckbox } from '@mui/material';

const Checkbox = ({ field, checked }) => <MaterialCheckbox {...field} checked={checked} />

export default Checkbox;